import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/icons/icon_question_gray.svg';
import _imports_1 from '@/assets/images/drop_down.svg';
var _hoisted_1 = {
  class: "form"
};
var _hoisted_2 = {
  class: "form-item"
};
var _hoisted_3 = {
  class: "label required"
};
var _hoisted_4 = {
  class: "text"
};
var _hoisted_5 = {
  class: "form-item"
};
var _hoisted_6 = {
  class: "label required"
};
var _hoisted_7 = {
  class: "text"
};
var _hoisted_8 = {
  class: "form-item"
};
var _hoisted_9 = {
  class: "label required"
};
var _hoisted_10 = {
  class: "text"
};
var _hoisted_11 = {
  class: "input-container"
};
var _hoisted_12 = {
  class: "reg"
};
var _hoisted_13 = {
  class: "text"
};
var _hoisted_14 = {
  class: "form-item"
};
var _hoisted_15 = {
  class: "label required"
};
var _hoisted_16 = {
  class: "text"
};
var _hoisted_17 = {
  class: "form-item"
};
var _hoisted_18 = {
  class: "label"
};
var _hoisted_19 = {
  class: "text"
};
var _hoisted_20 = {
  class: "form-item"
};
var _hoisted_21 = {
  class: "label required"
};
var _hoisted_22 = {
  class: "text"
};
var _hoisted_23 = {
  class: "input-container"
};
var _hoisted_24 = {
  class: "input-container"
};
var _hoisted_25 = {
  class: "form-item"
};
var _hoisted_26 = {
  class: "label required"
};
var _hoisted_27 = {
  class: "text"
};
var _hoisted_28 = {
  class: "form-item"
};
var _hoisted_29 = {
  class: "label"
};
var _hoisted_30 = {
  class: "text"
};
var _hoisted_31 = {
  class: "footer"
};
import PagePopupLayout from "@/layouts/PagePopupLayout.vue";
import { computed, ref } from "vue";
import Input from "../base/Input.vue";
import { ICDocTypeEnum, getICDocTypeOptions } from "@/constant/invoice.js";
import Dialog from "@/components/dialog/dialog";
import { useUserStore } from "@/store/userStore";
import { issueInvoice, updateTaxpayerInfo, associateInvoice } from "@/api/invoice";
import { unref } from "vue";
import { isLogin } from "@/utils/authUtil";
import { showDialog } from "vant";
import { Notify } from "@/utils/notifyUtil";
import { getUserDetail } from "@/api/user";
import { INVOICE_CANCEL_ERROR, INVOICE_ISSUE_ERROR } from "@/constant/responseCode";
import { INVOICE_ISSUE_DUP_ERROR } from "@/constant/responseCode";
import { showToast } from "@/utils/toastUtil";
import { Login } from "../login/LoginDialog";
import { useI18n } from "vue-i18n";
var noneTIN = "EI00000000010";
var noneIc = "000000000000";
export default {
  __name: 'InvoiceAddPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ""
    },
    shopId: {
      type: String,
      default: ""
    },
    orderType: {
      type: String,
      default: ""
    }
  },
  emits: ["update:show", "success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var emit = __emit;
    var userStore = useUserStore();
    var showRegSelectPopover = ref(false);
    var showStateSelectPopover = ref(false);
    var reMaxlength = ref(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ICDocTypeEnum.IC_NO, 12), ICDocTypeEnum.REGISTRATION_NO, 12), ICDocTypeEnum.PASSPORT_NO, 9), ICDocTypeEnum.MY_TENTERA_NO, 12));
    var isDisabled = computed(function () {
      return !form.value.name.trim() || !form.value.tin.trim() || !form.value.sst.trim() || !form.value.address.country || !form.value.address.city || !form.value.contact_number.trim() || !form.value.id_doc_no.trim();
    });
    var actions = getICDocTypeOptions().map(function (doc) {
      return {
        text: doc.label,
        value: doc.value,
        className: "reg__option"
      };
    });
    var onSelect = function onSelect(action) {
      return form.value.id_doc_type = action.value;
    };
    var onSelectState = function onSelectState(action) {
      form.value.address.state = action.name;
      showStateSelectPopover.value = false;
    };
    var regTextShow = computed(function () {
      var _actions$find;
      return (_actions$find = actions.find(function (a) {
        return a.value === form.value.id_doc_type;
      })) === null || _actions$find === void 0 ? void 0 : _actions$find.text;
    });
    var stateActions = ["Johor", "Kedah", "Kelantan", "Melaka", "Negeri Sembilan", "Pahang", "Pulau Pinang", "Perak", "Perlis", "Selangor", "Terengganu", "Sabah", "Sarawak", "Wilayah Persekutuan Kuala Lumpur", "Wilayah Persekutuan Labuan", "Wilayah Persekutuan Putrajaya", "Not Applicable"].map(function (s) {
      return {
        name: s
      };
    });
    var form = ref({
      name: "",
      tin: "",
      sst: "",
      email: "",
      address: {
        country: "Malaysia",
        state: "",
        city: "",
        postcode: "",
        detail: ""
      },
      id_doc_type: ICDocTypeEnum.REGISTRATION_NO,
      id_doc_no: "",
      contact_number: "",
      remark: ""
    });
    var props = __props;
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });
    var tinNone = function tinNone() {
      if (form.value.id_doc_no === noneIc) {
        return;
      }
      form.value.tin = noneTIN;
    };
    var icNone = function icNone() {
      if (form.value.tin === noneTIN) {
        return;
      }
      form.value.id_doc_no = noneIc;
    };
    var checkParams = function checkParams() {
      return true;
    };
    var submit = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _userStore$getUserInf;
        var params, res, invoiceRecordId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = unref(form);
              if (checkParams()) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return issueInvoice({
                order_id: props.orderId,
                order_type: props.orderType,
                shop_id: props.shopId,
                user_id: isLogin() ? (_userStore$getUserInf = userStore.getUserInfo) === null || _userStore$getUserInf === void 0 ? void 0 : _userStore$getUserInf.customer_id : undefined,
                is_save_taxpayer_info: props.orderType === "dishesOrder" ? false : true,
                buyer: _objectSpread(_objectSpread({}, params), {}, {
                  address: _objectSpread(_objectSpread({}, params.address), {}, {
                    address_line: [params.address.detail]
                  }),
                  trn_list: [{
                    number: params.sst,
                    tax_type: "sst"
                  }]
                })
              });
            case 5:
              res = _context.sent;
              if (res.isOK) {
                Notify.success(t("invoicingApplicationSubmitted"));
                showPopup.value = false;
                emit("success", res.data);
                invoiceRecordId = res.data.invoice_record_id; // if (props.orderType !== "delivery") return;
                if (!isLogin()) {
                  Dialog.confirm({
                    title: t("loginConfirm"),
                    desc: t("loginConfirmDesc"),
                    okText: t("loginNow"),
                    cancelText: t("noThanks"),
                    onOk: function onOk() {
                      Login.open({
                        onSuccess: function onSuccess() {
                          showToast(t("loginSuccessful"));
                          addTaxPayerInfo();
                          associateInvoice({
                            invoice_record_id: invoiceRecordId,
                            user_id: userStore.getCrmUserId,
                            shop_id: props.shopId
                          });
                        }
                      });
                    }
                  });
                } else {
                  getNewTaxpayerInfo();
                }
              } else if (res.code === INVOICE_ISSUE_DUP_ERROR) {
                Notify.error(t("invoiceIssueDupErrorDesc"));
              } else if (res.code === INVOICE_CANCEL_ERROR) {
                Notify.error(t("invoiceCancelErrorDesc"));
              } else if (res.code === INVOICE_ISSUE_ERROR) {
                Notify.error(t("invoiceIssueErrorDesc"));
              } else {
                Notify.error(res.msg || t("failed"));
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function submit() {
        return _ref3.apply(this, arguments);
      };
    }();
    var addTaxPayerInfo = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _userStore$getUserInf2;
        var list, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              list = userStore.getTaxpayerList;
              list.push(_objectSpread(_objectSpread({}, form.value), {}, {
                trn_list: [{
                  number: form.value.sst,
                  tax_type: "sst"
                }]
              }));
              _context2.next = 4;
              return updateTaxpayerInfo({
                user_id: (_userStore$getUserInf2 = userStore.getUserInfo) === null || _userStore$getUserInf2 === void 0 ? void 0 : _userStore$getUserInf2.customer_id,
                taxpayer_info_list: list
              });
            case 4:
              res = _context2.sent;
              if (res.isOK) {
                Notify.success(t("saveSuccessfully"));
                getNewTaxpayerInfo();
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function addTaxPayerInfo() {
        return _ref4.apply(this, arguments);
      };
    }();
    var getNewTaxpayerInfo = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getUserDetail();
            case 2:
              res = _context3.sent;
              if (res.isOK) {
                userStore.setUserInfo(res.data);
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function getNewTaxpayerInfo() {
        return _ref5.apply(this, arguments);
      };
    }();
    var showTip = function showTip(key) {
      var messages = {
        name: t("invoiceName"),
        tin: t("invoiceTin"),
        ic: t("invoiceIC"),
        sst: t("invoiceSST"),
        address: t("invoiceAddress"),
        email: t("invoiceEmail"),
        contact: t("invoiceContact")
      };
      showDialog({
        message: messages[key]
      });
    };
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_van_popover = _resolveComponent("van-popover");
      var _component_van_action_sheet = _resolveComponent("van-action-sheet");
      var _component_Button = _resolveComponent("Button");
      return _openBlock(), _createBlock(PagePopupLayout, {
        ref: "pagePopupRef",
        show: showPopup.value,
        "onUpdate:show": _cache[22] || (_cache[22] = function ($event) {
          return showPopup.value = $event;
        }),
        title: _ctx.$t('issueInvoice'),
        class: "invoice-add",
        "show-footer": ""
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_31, [_createVNode(_component_Button, {
            type: "content",
            disabled: isDisabled.value,
            class: "btn",
            onClick: submit
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("submit")), 1)];
            }),
            _: 1
          }, 8, ["disabled"])])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_Gap, {
            h: 0.1
          }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("name")), 1), _createElementVNode("img", {
            class: "icon",
            src: _imports_0,
            alt: "",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return showTip('name');
            })
          })]), _createVNode(Input, {
            modelValue: form.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return form.value.name = $event;
            }),
            placeholder: _ctx.$t('input'),
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("tinNo")), 1), _createElementVNode("img", {
            class: "icon",
            src: _imports_0,
            alt: "",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return showTip('tin');
            })
          })]), _createVNode(Input, {
            modelValue: form.value.tin,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return form.value.tin = $event;
            }),
            placeholder: _ctx.$t('nDigits', ['11-14']),
            clearable: "",
            maxlength: "14"
          }, {
            "right-icon": _withCtx(function () {
              return [_createElementVNode("span", {
                class: _normalizeClass(["none-btn", {
                  disabled: form.value.id_doc_no === noneIc
                }]),
                onClick: tinNone
              }, _toDisplayString(_ctx.$t("none")), 3)];
            }),
            _: 1
          }, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("businessRegistrationNoICPassportNo")), 1), _createElementVNode("img", {
            class: "icon",
            src: _imports_0,
            alt: "",
            onClick: _cache[4] || (_cache[4] = function ($event) {
              return showTip('ic');
            })
          })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_popover, {
            show: showRegSelectPopover.value,
            "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
              return showRegSelectPopover.value = $event;
            }),
            actions: _unref(actions),
            onSelect: onSelect
          }, {
            reference: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(regTextShow.value), 1), _cache[23] || (_cache[23] = _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              }, null, -1))])];
            }),
            _: 1
          }, 8, ["show", "actions"]), _createVNode(Input, {
            modelValue: form.value.id_doc_no,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return form.value.id_doc_no = $event;
            }),
            placeholder: _ctx.$t('nDigits', [reMaxlength.value[form.value.id_doc_type]]),
            clearable: "",
            maxlength: reMaxlength.value[form.value.id_doc_type]
          }, {
            "right-icon": _withCtx(function () {
              return [_createElementVNode("span", {
                class: _normalizeClass(["none-btn", {
                  disabled: form.value.tin === noneTIN
                }]),
                onClick: icNone
              }, _toDisplayString(_ctx.$t("none")), 3)];
            }),
            _: 1
          }, 8, ["modelValue", "placeholder", "maxlength"])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("sstNo")), 1), _createElementVNode("img", {
            class: "icon",
            src: _imports_0,
            alt: "",
            onClick: _cache[7] || (_cache[7] = function ($event) {
              return showTip('sst');
            })
          })]), _createVNode(Input, {
            modelValue: form.value.sst,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
              return form.value.sst = $event;
            }),
            placeholder: _ctx.$t('nDigits', ['15']),
            clearable: "",
            maxlength: "15"
          }, {
            "right-icon": _withCtx(function () {
              return [_createElementVNode("span", {
                class: "none-btn",
                onClick: _cache[8] || (_cache[8] = function () {
                  return form.value.sst = 'NA';
                })
              }, _toDisplayString(_ctx.$t("none")), 1)];
            }),
            _: 1
          }, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("email")), 1), _createElementVNode("img", {
            class: "icon",
            src: _imports_0,
            alt: "",
            onClick: _cache[10] || (_cache[10] = function ($event) {
              return showTip('email');
            })
          })]), _createVNode(Input, {
            modelValue: form.value.email,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
              return form.value.email = $event;
            }),
            placeholder: _ctx.$t('input'),
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("address")), 1), _createElementVNode("img", {
            class: "icon",
            src: _imports_0,
            alt: "",
            onClick: _cache[12] || (_cache[12] = function ($event) {
              return showTip('address');
            })
          })]), _createElementVNode("div", _hoisted_23, [_createVNode(Input, {
            modelValue: form.value.address.country,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
              return form.value.address.country = $event;
            }),
            class: "country",
            disabled: ""
          }, null, 8, ["modelValue"]), _createElementVNode("div", {
            class: "state",
            onClick: _cache[14] || (_cache[14] = function ($event) {
              return showStateSelectPopover.value = true;
            })
          }, [_createElementVNode("span", {
            class: _normalizeClass(["text text-ellipsis-1", {
              empty: !form.value.address.state
            }])
          }, _toDisplayString(form.value.address.state || _ctx.$t("cityMandatory")), 3), _cache[24] || (_cache[24] = _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          }, null, -1))])]), _createVNode(_component_Gap, {
            h: 0.1
          }), _createElementVNode("div", _hoisted_24, [_createVNode(Input, {
            modelValue: form.value.address.city,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
              return form.value.address.city = $event;
            }),
            placeholder: _ctx.$t('cityMandatory'),
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"]), _createVNode(Input, {
            modelValue: form.value.address.postcode,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
              return form.value.address.postcode = $event;
            }),
            placeholder: _ctx.$t('postcodeOptional'),
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"])]), _createVNode(_component_Gap, {
            h: 0.1
          }), _createVNode(Input, {
            modelValue: form.value.address.detail,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
              return form.value.address.detail = $event;
            }),
            placeholder: _ctx.$t('detailAddressOptional'),
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("contactNo")), 1), _createElementVNode("img", {
            class: "icon",
            src: _imports_0,
            alt: "",
            onClick: _cache[18] || (_cache[18] = function ($event) {
              return showTip('contact');
            })
          })]), _createVNode(Input, {
            modelValue: form.value.contact_number,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) {
              return form.value.contact_number = $event;
            }),
            placeholder: _ctx.$t('input'),
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("notes")), 1)]), _createVNode(Input, {
            modelValue: form.value.remark,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
              return form.value.remark = $event;
            }),
            "self-type": "borderTextarea",
            type: "textarea",
            placeholder: _ctx.$t('input'),
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"])]), _createVNode(_component_van_action_sheet, {
            show: showStateSelectPopover.value,
            "onUpdate:show": _cache[21] || (_cache[21] = function ($event) {
              return showStateSelectPopover.value = $event;
            }),
            actions: _unref(stateActions),
            onSelect: onSelectState
          }, null, 8, ["show", "actions"])])];
        }),
        _: 1
      }, 8, ["show", "title"]);
    };
  }
};